// REMOVE "use client";
import Link from "next/link";
import Image from "next/image";

const fallbackImg = "/placeholder.jpg";

export default function PostCard({ post }) {
    if (!post) return null;

    const { slug, title, excerpt, categorySlug, coverImage, image } = post;
    const imageUrl = coverImage || image || fallbackImg;
    const href = `/articles/${slug}`;

    return (
        <article
            role="listitem"
            className="group rounded-2xl overflow-hidden border border-gray-100/80 dark:border-zinc-800
                       bg-white dark:bg-zinc-900 shadow-sm hover:shadow-md transition-shadow"
            aria-label={title}
        >
            <Link
                href={href}
                className="block outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-zinc-900"
            >
                <div className="relative w-full aspect-[3/3]">
                    <Image
                        src={imageUrl}
                        alt={title || "Post image"}
                        fill
                        className="object-cover object-center transition-transform duration-300 group-hover:scale-[1.02]"
                        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        loading="lazy"
                        placeholder="blur"
                        blurDataURL="/placeholder.jpg"
                    />
                </div>

                <div className="p-4 sm:p-5">
                    {categorySlug && (
                        <div className="mb-2">
                            <span
                                className="inline-block text-[10px] sm:text-xs font-semibold uppercase tracking-widest
                                             text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-500/10
                                             rounded px-2 py-0.5"
                            >
                                {categorySlug}
                            </span>
                        </div>
                    )}
                    <h2 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-gray-100 mb-1 line-clamp-2">
                        {title}
                    </h2>
                    {excerpt && (
                        <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-3">
                            {excerpt}
                        </p>
                    )}
                    <span className="mt-3 inline-block text-sm font-medium text-blue-700 dark:text-blue-300">
                        Read more →
                    </span>
                </div>
            </Link>
        </article>
    );
}
